// extracted by mini-css-extract-plugin
export var filterIncDec = "_3s-0";
export var leftBorder = "_3s-1";
export var rightBorder = "_3s-2";
export var stringInput = "_3s-3";